import styled from "vue-styled-components";

export const Content = styled.div`
    width: 100%;
    min-width: 100%;
    
    details {
        border: solid 1px #fafafa;
        border-radius: 0.25rem;
        transition: filter 0.25s;
        will-change: filter;

        &:first-child {
            margin-top: 24px;
        }

        summary {
            background: ${props => props.theme?.background_color_site ?? "#ffffff"};
            list-style: none;
            cursor: pointer;
            font-weight: 500;
            padding: 1.2rem;
            font-size: 1.4rem;
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid ${props => props.theme?.border_color_site ?? "#e9ecef"};

            i {
                transition: rotate 0.2s;
            }
        }

        .answers {
            font-size: 14px;
            line-height: 21px;
            padding: 1.2rem;
            margin: 0;

            li + li {
                margin-top: 0.7rem;
            }

            li {
                display: flex;
                align-items: center;
                justify-content: space-between;                
                cursor: pointer;

                > div {
                    display: flex;
                    align-items: center;
                    gap: 0.7rem;
                }

                .checkbox {
                    width: 2.2rem;
                    height: 2.2rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: ${props => props.theme?.text_site_color ?? '#4a505e'};
                    background: ${props => props.theme?.background_color_site ?? "#ffffff"};
                    border: 1px solid ${props => props.theme?.border_color_site ?? "#e9ecef"};
                }

                img {
                    max-width: 10rem;
                }
            }
        }

        &[open] {
            summary i.icon-angle-left {
                rotate: -90deg;
            }
        }

        &:hover {
            summary {
                filter: brightness(0.97);
            }
        }
    }
`;
